import { useState, useContext } from 'react';
import papaparse from 'papaparse';
import lodash from 'lodash';
import { AppContext, EMPTY_STRING, EQuestionBankCsvStatus } from 'commons-ui';
import { useHistory } from 'react-router-dom';
import { EDowntimeType } from 'pages/dashboard/scheduledDowntime/utils/constants';
import useService from '../utils/useService';
import { prepareZkjContestDetails, prepareZkjAnswerDetails, actionOptions, ZKJ_UPLOAD_Q_A_OPTIONS } from '../utils';
import { IZupeeKheloJeetoUploadQnA, ICsvToJson, IActionOptions, IZupeeKheloJeetoUploadAnswers } from '../model';

const useUpload = () => {
	const [csvFile, setCSVFile] = useState<File | null>(null);
	const [showLoader, setShowLoader] = useState(false);
	const [selectedAction, setSelectedAction] = useState([actionOptions[0]]);
	const { app, showAlert } = useContext(AppContext);
	const { requestUploadAddQuestions, requestUploadAnswers } = useService();
	const history = useHistory();

	const handleActionChange = (value: IActionOptions[]) => {
		setSelectedAction(value);
	};

	const handleFileUpload = async (uploadedFiles: File[]) => {
		const file = lodash.first(uploadedFiles);
		if (!lodash.isEmpty(file)) await setCSVFile(file);
	};

	const CSVtoJSON = (csvText: string): ICsvToJson[] => {
		const parsedData: any = papaparse.parse(csvText, { header: true, skipEmptyLines: true });
		return parsedData.data;
	};

	const uploadQuestions = async (jsonData: ICsvToJson[]) => {
		if (!jsonData) return;
		setShowLoader(true);
		let resp;
		if (selectedAction?.[0]?.id === ZKJ_UPLOAD_Q_A_OPTIONS.addQuestions) {
			const questionDetails: IZupeeKheloJeetoUploadQnA = prepareZkjContestDetails(jsonData);
			resp = await requestUploadAddQuestions(app.appName, questionDetails);
		} else if (selectedAction?.[0]?.id === ZKJ_UPLOAD_Q_A_OPTIONS.addAnswers) {
			const answerDetails: IZupeeKheloJeetoUploadAnswers = prepareZkjAnswerDetails(jsonData);
			resp = await requestUploadAnswers(app.appName, answerDetails);
		}
		if (resp?.data?.success) showAlert('CSV upload successfully.', { type: EQuestionBankCsvStatus.SUCCESS });
		else
			showAlert(resp?.data?.externalMessage || 'some error ocurred while uploading csv', {
				type: EQuestionBankCsvStatus.FAILED,
				duration: EDowntimeType.MEDIUM
			});
		history.goBack();
	};

	const uploadCsvFile = () => {
		if (!csvFile) return;

		const reader = new FileReader();
		reader.onload = () => {
			const text: string = reader.result?.toString() || EMPTY_STRING;
			const data: ICsvToJson[] = CSVtoJSON(text);
			uploadQuestions(data);
		};
		reader.readAsText(csvFile);
	};

	return {
		showLoader,
		showAlert,
		csvFile,
		selectedAction,
		handleFileUpload,
		uploadCsvFile,
		handleActionChange
	};
};

export default useUpload;
